import React, { useState } from 'react'
import Spinner from '../Spinner/Spinner'

type Props = {
  invoiceUrl: string
}

const InvoiceIframe = ({ invoiceUrl }: Props) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true)

  return (
    <div className="w-full h-[600px] block">
      {isIframeLoading && (
        <div className="relative h-40">
          <Spinner />
        </div>
      )}

      {invoiceUrl && (
        <iframe
          className="block w-full h-[600px]"
          onLoad={() => setIsIframeLoading(false)}
          src={invoiceUrl}
        />
      )}
    </div>
  )
}

export default InvoiceIframe
